import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { getFirstAccessibleRoute } from '@domain/aplication/navigation-permissions';
import { AplicationService } from '@services/aplication/aplication.service';

export const loginGuard: CanActivateFn = () => {
    const msalService = inject(MsalService);
    const aplicationService = inject(AplicationService);
    const router = inject(Router);

    const account = msalService.instance.getActiveAccount();

    if (account) {
        const isAdmin = aplicationService.selectedAplicationIsAdmin();
        const hasImpersonate = aplicationService.selectedAplicationHasImpersonate();
        const fallback = getFirstAccessibleRoute(isAdmin, hasImpersonate) ?? '/offers';

        router.navigate([fallback]);
        return false;
    }

    return true;
};
